import type { WalletAddressWithType } from '../../walletAccount/walletAccount.types';
import type { WalletProviderConnectResult } from '../../walletProvider/walletProvider.types';

export const getAddressesWithTypesFromConnectionResult = (
  connectionResult: WalletProviderConnectResult
): WalletAddressWithType[] => {
  return connectionResult.addresses.filter(
    (address): address is WalletAddressWithType =>
      !!address.address && !!address.type
  );
};
